function articleCaption() {
  $('.post-content img').each(function() {
    const $this = $(this);
    const imageAlt = $this.attr('alt');
    if (imageAlt.length) {
      $this.after(`<div class="caption">${imageAlt}</div>`);
    }
  })
}

export default articleCaption();



// WEBPACK FOOTER //
// ../markup/assets/js/article-caption.js